import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

export const useGoogleAnalytics = () => {
  useEffect(() => {
    // Initialize Google Analytics
    window.dataLayer = window.dataLayer || [];
    
    // Create gtag function and assign to window for global access
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    
    // Assign to window so it's available globally
    window.gtag = gtag;

    // Load the Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script);

    // Initialize gtag
    gtag('js', new Date());
    gtag('config', GOOGLE_ANALYTICS_ID);

    // Clean up
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      // Don't remove window.gtag as it may be used elsewhere
    };
  }, []);
};
